/* eslint-disable */
import { useEffect, useRef } from 'react';
import styles from './InternalLogsPage.module.scss';

const LEVEL_CLASS = {
	ERROR: styles.lvlError,
	CRITICAL: styles.lvlError,
	WARNING: styles.lvlWarn,
	WARN: styles.lvlWarn,
	INFO: styles.lvlInfo,
	DEBUG: styles.lvlDebug,
};

function renderText(text, query) {
	if (!query) return text;
	const idx = text.toLowerCase().indexOf(query.toLowerCase());
	if (idx === -1) return text;
	return (
		<>
			{text.slice(0, idx)}
			<mark className={styles.match}>{text.slice(idx, idx + query.length)}</mark>
			{text.slice(idx + query.length)}
		</>
	);
}

export default function LogViewer({
	lines = [],
	query = '',
	atStart = false,
	atEnd = false,
	onLoadOlder,
	onLoadNewer,
	followBottom = false,
	scrollTo = null,
}) {
	const bottomRef = useRef(null);
	const anchorRef = useRef(null);
	useEffect(() => {
		if (followBottom && bottomRef.current) {
			bottomRef.current.scrollIntoView({ block: 'end' });
		}
	}, [lines, followBottom]);
	// Center the clicked/jumped line in the viewport (search-result open, jump-to-time).
	// Keyed on scrollTo (new identity per open) so paging older/newer doesn't yank you back.
	useEffect(() => {
		if (scrollTo && anchorRef.current) {
			anchorRef.current.scrollIntoView({ block: 'center' });
		}
	}, [scrollTo]);

	return (
		<div className={styles.viewer}>
			<div className={styles.viewerBar}>
				<button type='button' disabled={atStart} onClick={onLoadOlder}>↑ Load older</button>
				<span className={styles.count}>{lines.length} lines</span>
				<button type='button' disabled={atEnd} onClick={onLoadNewer}>↓ Load newer</button>
			</div>
			<pre className={styles.lines}>
				{lines.map((ln, i) => {
					const isAnchor = scrollTo != null && ln.offset === scrollTo.offset;
					return (
						<div
							key={`${ln.offset}-${i}`}
							ref={isAnchor ? anchorRef : null}
							className={`${styles.line} ${LEVEL_CLASS[ln.level] || ''} ${isAnchor ? styles.anchorLine : ''}`}
						>
							{renderText(ln.text, query)}
						</div>
					);
				})}
				<div ref={bottomRef} />
			</pre>
		</div>
	);
}
